export const groupChats = [
  {
    id: 'g1',
    title: '加班群の深夜突变',
    meta: '18 人 · 凌晨 1:24 高能',
    messages: [
      { id: 'g1-1', name: '阿豆', text: '今天也是不想动的一天（发送表情包）', side: 'left' },
      { id: 'g1-2', name: '西瓜太郎', text: '这张图我好像在哪见过', side: 'left' },
      { id: 'g1-3', name: '瓜田守望者', text: '（发送同一张表情包）', side: 'right' },
      { id: 'g1-4', name: '阿豆', text: '你们倒是很诚实', side: 'left' },
      { id: 'g1-5', name: '管理员小吕', text: '别刷屏了啊各位', side: 'left' },
      { id: 'g1-6', name: '管理员小吕', text: '……这张图发我一份', side: 'left' },
      { id: 'g1-7', name: '西瓜太郎', text: '哈哈哈哈管理员破防了', side: 'right' },
    ],
  },
  {
    id: 'g2',
    title: '同学群の接梗接力',
    meta: '32 人 · 下午 4:07 高能',
    messages: [
      { id: 'g2-1', name: '小满', text: '老师今天点名点到我名字的时候，我整个人是空白的', side: 'left' },
      { id: 'g2-2', name: '咸鱼同学', text: '我当时第一反应是——这剧本我没拿到啊', side: 'right' },
      { id: 'g2-3', name: '小满', text: '别接了别接了，我还没缓过来', side: 'left' },
      { id: 'g2-4', name: '晚风', text: '（接）这剧本我也没拿到', side: 'left' },
      { id: 'g2-5', name: '晚风', text: '（再改）这剧本全班都没拿到', side: 'left' },
      { id: 'g2-6', name: '咸鱼同学', text: '好了，这个话题到此为止（继续造梗）', side: 'right' },
    ],
  },
  {
    id: 'g3',
    title: '兴趣群の午夜创作',
    meta: '64 人 · 凌晨 2:40 高能',
    messages: [
      { id: 'g3-1', name: '梗图搬运工', text: '我刚把今天那个片段做成图了，先发为敬', side: 'left' },
      { id: 'g3-2', name: '排版强迫症', text: '字体再大一号会更好笑', side: 'right' },
      { id: 'g3-3', name: '梗图搬运工', text: '改了（发送第二版）', side: 'left' },
      { id: 'g3-4', name: '夜猫子协会', text: '这个版本可以，我转出去了', side: 'right' },
      { id: 'g3-5', name: '排版强迫症', text: '明天早上群里肯定全是这张图', side: 'right' },
      { id: 'g3-6', name: '夜猫子协会', text: '预言家，明天见', side: 'right' },
    ],
  },
];